import { hubRecordId } from './destinationType.js';
import {
  buildLocationHubParentMap,
  isCrossingDestination,
  routeMatchesMlFromTo,
} from './routeDisplay.js';

/** From hub + all branches under selected hub(s). */
export const expandFromHubFamilies = (fromIds, locations = []) => {
  const selected = new Set((fromIds || []).map((id) => String(id)));
  const out = new Set();
  (locations || []).forEach((loc) => {
    const id = Number(hubRecordId(loc));
    if (Number.isNaN(id)) return;
    const parentRaw = loc.parent_hub_id;
    const parent = parentRaw != null && parentRaw !== '' ? Number(parentRaw) : id;
    if (selected.has(String(id)) || selected.has(String(parent))) {
      out.add(id);
    }
  });
  (fromIds || []).forEach((raw) => {
    const id = Number(raw);
    if (!Number.isNaN(id)) out.add(id);
  });
  return out;
};

/** To hub + child branches only (no sibling branches). */
export const expandToDestinationHubs = (toIds, locations = []) => {
  const selected = new Set((toIds || []).map((id) => String(id)));
  const out = new Set();
  (toIds || []).forEach((raw) => {
    const id = Number(raw);
    if (!Number.isNaN(id)) out.add(id);
  });
  (locations || []).forEach((loc) => {
    const id = Number(hubRecordId(loc));
    if (Number.isNaN(id)) return;
    const parent = loc.parent_hub_id;
    if (parent != null && parent !== '' && selected.has(String(parent))) {
      out.add(id);
    }
  });
  return out;
};

export const isMlPickerEligibleStatus = (shipment) => {
  const status = String(shipment?.status || '').toUpperCase().replace(/\s+/g, '_');
  if (status === 'BOOKED') return true;
  const ogcl = String(shipment?.ogcl_transfer_status || '').toUpperCase();
  return ogcl === 'APPROVED';
};

/**
 * Keep only shipments matching ML From/To (and optional saved route corridor).
 */
export const filterShipmentsForMlDispatchForm = (
  shipments,
  {
    locations = [],
    fromIds = [],
    toIds = [],
    route = null,
    parentMap = null,
  } = {},
) => {
  if (!Array.isArray(shipments) || !shipments.length) return [];
  if (!fromIds.length || !toIds.length) return [];

  const map = parentMap || buildLocationHubParentMap(locations);
  const fromSet = expandFromHubFamilies(fromIds, locations);
  const toSet = expandToDestinationHubs(toIds, locations);

  return shipments.filter((shipment) => {
    if (!isMlPickerEligibleStatus(shipment)) return false;

    const senderId = Number(shipment.sender_location_hub_id);
    const receiverId = Number(shipment.receiver_location_hub_id);
    if (Number.isNaN(senderId) || Number.isNaN(receiverId)) return false;

    if (!fromSet.has(senderId)) return false;

    const onSelectedTo = toSet.has(receiverId);
    const crossesOnRoute = Boolean(
      route?.id && isCrossingDestination(route, receiverId, map),
    );
    if (!onSelectedTo && !crossesOnRoute) return false;

    if (route?.id) {
      return routeMatchesMlFromTo(route, [senderId], [receiverId], map);
    }
    return true;
  });
};
